import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Variants follow the app's button set (dataroom CLAUDE.md §8, §13): one
// primary, a secondary outline, and inverse pairs for navy bands. No soft
// buttons, no hover lift.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary-900 text-white hover:bg-primary-800",
        secondary:
          "border border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-50",
        inverse:
          "bg-white text-primary-900 hover:bg-neutral-100 focus-visible:ring-offset-primary-900",
        "inverse-outline":
          "border border-primary-400 text-white hover:bg-primary-800 focus-visible:ring-offset-primary-900",
        destructive:
          "border border-error-300 text-error-700 hover:bg-error-50",
        outline:
          "border border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-50",
        ghost: "text-neutral-700 hover:bg-neutral-100",
        link: "text-primary-900 underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-6 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
